module.exports = __webpack_public_path__ + "static/media/bi-logo.71ade621.svg";